import { Suspense, lazy } from 'react';
import PageLoader from 'components/PageLoader';
import { AppRouteComponentProps } from 'components/AppRoutes';
import {
  usePageAccessible,
  useEditScorecardPageData,
  useScorecardFormVariant,
} from 'hooks';

const ViewScorecardComponent = lazy(() => import('./ViewScorecard.component'));

export default function ViewScorecard(props: AppRouteComponentProps) {
  const variant = useScorecardFormVariant();
  const { scorecard, loading, notFound, onBackClick, hasAccess } =
    useEditScorecardPageData(usePageAccessible(props), variant, false);

  return (
    <Suspense fallback={<PageLoader open />}>
      {loading ? (
        <PageLoader open />
      ) : (
        <ViewScorecardComponent
          hasAccess={hasAccess}
          notFound={notFound}
          onBackClick={onBackClick}
          scorecard={scorecard!}
          variant={variant}
        />
      )}
    </Suspense>
  );
}
